import { render, staticRenderFns } from "./ListaCategoriasSilenciadas.vue?vue&type=template&id=6adc1012"
import script from "./ListaCategoriasSilenciadas.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaCategoriasSilenciadas.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports